import {t} from '@lingui/macro';
import React, {FC} from 'react';
import styled from 'styled-components';

import {HandlerOf} from '../../../libs/shared/helpers/src/react/reactHelpers';
import {BoxedInput} from '../../../libs/shared/ui/src/components/boxedInputs/boxedInput';
import {BoxedInputElement} from '../../../libs/shared/ui/src/components/boxedInputs/boxedInputElement';
import {BoxedInputIcon} from '../../../libs/shared/ui/src/components/boxedInputs/boxedInputIcon';
import {Icon} from '../../../libs/shared/ui/src/components/icon/icon';
import {InputTypesEnum} from '../../../libs/shared/ui/src/components/inputs/input';
import {VisualSizesEnum} from '../../../libs/shared/ui/src/styles/commonStyles';
import {useLocalize} from '../../../srcCommon/internationalization/internationalizationContext';
import {StyledExitButton} from '../topbar/search/settingsTopbarSearch';

/*
 * Props.
 */

interface SettingsSearchInputProps {
  value: string | undefined;
  onChange: HandlerOf<string | undefined>;
  className?: string;
}

/*
 * Styles.
 */

const StyledBoxedInputElement = styled(BoxedInputElement)`
  margin-left: 1px;
`;

/*
 * Component.
 */

export const SettingsSearchInput: FC<SettingsSearchInputProps> = ({value, className, onChange}) => {
  const localize = useLocalize();

  return (
    <BoxedInput noMargin size={VisualSizesEnum.MEDIUM} className={className}>
      {(childProps) => (
        <>
          <BoxedInputIcon {...childProps} iconName="searchSmall" />
          <StyledBoxedInputElement
            {...childProps}
            type={InputTypesEnum.TEXT}
            onChange={(v) => onChange(v)}
            hasSpellCheck={false}
            value={value ?? ''}
            placeholder={localize(t('settings-search-input-placeholder')`Search`)}
          />
          {value && (
            <StyledExitButton onClick={() => onChange('')}>
              <Icon name="exitFilledSmall" />
            </StyledExitButton>
          )}
        </>
      )}
    </BoxedInput>
  );
};
